import { render, staticRenderFns } from "./CompanionOptions.vue?vue&type=template&id=2d654470&"
import script from "./CompanionOptions.vue?vue&type=script&lang=js&"
export * from "./CompanionOptions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports